import set from 'lodash/set';
import { updateValidation, updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { setViewId } from './AccountsStepActions';
import { OVERVIEW } from './AccountsStepViews';
import { BACKEND_KEY } from '../../AccountsWorkflowConstants';

export const onCancel = (workflowId, clientId, accountDraft, graphAccounts) => (dispatch) => {
  if (
    accountDraft.frontEndId &&
    accountDraft.frontEndId === graphAccounts[graphAccounts.length - 1].frontEndId
  ) {
    dispatch(updateData(
      {
        [BACKEND_KEY]: graphAccounts.slice(0, graphAccounts.length - 1),
      },
      workflowId,
      clientId,
    ));
  }
  dispatch(updateValidation(set({}, `${BACKEND_KEY}.AccountAddEdit`, []), workflowId, clientId));
  dispatch(setViewId(OVERVIEW, workflowId, clientId));
};

export default onCancel;
